<div class="externalContainer">
  <iframe
    [src]="safeUrl"
    style="width: 100%; height: 100%; min-height: 600px"
    frameborder="0"
  ></iframe>
</div>
